import {
  AIR_SEARCH_DATA,
  CAR_SEARCH_DATA,
  HOTEL_SEARCH_DATA,
  PACKAGE_SEARCH_DATA,
} from '@/shared-utils/local-forage-helper'

export const mapTypeToCode = {
  AIRPORT: 'A',
  CITY: 'C',
  HOTEL: 'H',
  POI: 'P',
  GEO: 'GEO',
  LATLON: 'LATLON',
  PARTNER_LOC: 'PARTNER_LOC',
  GDS_CITY: 'GDS_CITY',
  ADDRESS: 'ADDRESS',
  HOTEL_CITY: 'HOTEL_CITY',
  NEIGHBOURHOOD: 'N',
} as const

export const recentSearchesKey = {
  cars: CAR_SEARCH_DATA,
  hotels: HOTEL_SEARCH_DATA,
  hotelsV2: HOTEL_SEARCH_DATA,
  flights: AIR_SEARCH_DATA,
  packagesOrigin: PACKAGE_SEARCH_DATA,
  packagesDestination: PACKAGE_SEARCH_DATA,
  flightsNearbyAirport: AIR_SEARCH_DATA,
} as const
